import { render, staticRenderFns } from "./collectionUnit.vue?vue&type=template&id=26f444d0&scoped=true&"
import script from "./collectionUnit.vue?vue&type=script&lang=js&"
export * from "./collectionUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f444d0",
  null
  
)

export default component.exports